import { FiCheck, FiStar } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const FilterSidebar = ({
  minRating,
  setMinRating,
  categories,
  currentCategory,
}) => {
  const location = useLocation();
  return (
    <div className="card p-5 sticky top-24 space-y-5">
      <div>
        <h3 className="text-xs font-extrabold uppercase tracking-widest text-slate-800 mb-3">
          Minimum Rating
        </h3>
        <div className="space-y-1">
          {[0, 4, 4.5, 4.8].map((r) => (
            <button
              key={r}
              onClick={() => setMinRating(r)}
              className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                minRating === r
                  ? "bg-indigo-50 text-indigo-700 border-2 border-indigo-200"
                  : "text-slate-600 hover:bg-slate-50 border-2 border-transparent"
              }`}
            >
              <span className="flex items-center gap-2">
                <FiStar
                  size={13}
                  className={
                    minRating === r ? "text-indigo-500" : "text-slate-400"
                  }
                />
                {r === 0 ? "All ratings" : `${r}+ stars`}
              </span>
              {minRating === r && (
                <FiCheck size={14} className="text-indigo-500" />
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="border-t-2 border-slate-100 pt-5">
        <h3 className="text-xs font-extrabold uppercase tracking-widest text-slate-800 mb-3">
          Category
        </h3>
        <div className="space-y-0.5 max-h-80 overflow-y-auto">
          <Link
            to="/websites"
            className={`flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-semibold transition-all ${
              !currentCategory && location.pathname === "/websites"
                ? "bg-indigo-50 text-indigo-700 border-2 border-indigo-200"
                : "text-slate-600 hover:bg-slate-50 border-2 border-transparent"
            }`}
          >
            All categories
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                currentCategory === cat.slug
                  ? "bg-indigo-50 text-indigo-700 border-2 border-indigo-200"
                  : "text-slate-600 hover:bg-slate-50 border-2 border-transparent"
              }`}
            >
              <span>{cat.name}</span>
              <span className="text-xs font-bold text-slate-400">
                {cat.count}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
